import Canvg from 'canvg';
import React from 'react'
import ReactDOMServer from "react-dom/server";
import { DoorImage } from '../components/DoorEditor/DoorImage';
import { DrawContext } from '../components/EditorCommon/DrawContext';
import { CommonEditorProps, EditorContext } from "../components/EditorCommon/EditorContext";
import { InteriorImage } from '../components/InteriorEditor/InteriorImage';
import { IHttpService } from "./LoginService";
import { Cabinet, CabinetClient, IUserSolution, IVec2d, SaveCabinetRequest } from "./WebApiClient";


export class SaveService {
    cabinetClient: CabinetClient;
    constructor(http: IHttpService) {

        this.cabinetClient = new CabinetClient(undefined, http);

    }

    async save(editorContext: CommonEditorProps, name: string, overwrite: boolean): Promise<IUserSolution> {
        let cabinet = editorContext.cabinet;
        if (overwrite && cabinet.orderNumber !== null) {
            throw new Error("Cannot overwrite a solution that has already been ordered");
        }
        if (overwrite && cabinet.userSolutionId === null) {
            throw new Error("Cannot overwrite a solution that wasn't saved in the first place");
        }
        if (!overwrite) {
            cabinet = {
                ...cabinet,
                userSolutionId: null,
            }
        }
        const images = await this.getImages(editorContext);
        const errorFlags = editorContext.cabinetService.getErrorFlags();
        const req = new SaveCabinetRequest({
            cabinet: new Cabinet(cabinet),
            name,
            doorImageB64Png: images.doorImage,
            interiorImageB64Png: images.interiorImage,
            errorFlags: errorFlags
        });
        const serverSolution = await this.cabinetClient.saveCabinet(req);
        await editorContext.cabinetService.loadSavedCabinet(serverSolution.id, this.cabinetClient);
        return serverSolution
    }

    private async getImages(editorContext: CommonEditorProps) {
        const size: IVec2d = {
            x: 800,
            y: 600
        };
        let doorImage = null;
        try {
            doorImage = await this.toPng(React.createElement(
                DoorImage,
                { width: size.x, height: size.y }
            ),
                "Door image",
                editorContext
            );
        } catch (e) {
            //Ignore error - better to ignore than to crash here
            //TODO log error
        }

        let interiorImage = null;
        try {
            interiorImage = await this.toPng(React.createElement(
                InteriorImage,
                { width: size.x, height: size.y, displayHelpTextOnEmpty: false }
            ),
                "Interior image",
                editorContext
            );
        } catch (e) {
            //Ignore error - better to ignore than to crash here
            //TODO log error
        }
        return { doorImage, interiorImage };
    }


    private async toPng(svgElement: JSX.Element, imageName: string, editorContext: CommonEditorProps): Promise<string> {
        const size: IVec2d = {
            x: 800,
            y: 600
        };
        await Promise.resolve();
        try {
            //const elem = (
            //    <EditorContext.Provider value= { editorContext } >
            //    { svgElement }
            //    < /EditorContext.Provider>
            //);
            const editorContextElem = React.createElement(
                EditorContext.Provider,
                { value: editorContext },
                svgElement
            );
            const drawContextElem = React.createElement(
                DrawContext.Provider,
                { value: { preserveAspectRatio: "none" } },
                editorContextElem
            );

            const markup = ReactDOMServer.renderToStaticMarkup(drawContextElem);


            const canvas = document.createElement('canvas');
            document.body.appendChild(canvas);
            canvas.style.display = "none";
            canvas.width = size.x;
            canvas.height = size.y;
            const ctx = canvas.getContext("2d");
            if (!ctx)
                throw new Error("Could not get 2d canvas context");

            const v = Canvg.fromString(ctx, markup, {
                ignoreMouse: true,
                ignoreAnimation: true,
                window,

            });
            await v.render();

            let dataUrl = canvas.toDataURL("image/png");
            return dataUrl;
        } catch (e) {
            if (e instanceof Error) {
                throw new Error(`Failed to convert ${imageName} to png: ${e.message}\n${e.stack}`);
            }
            throw e;
        }
    }
}
